export const THEME_STORAGE_KEY = 'noccarc-theme';

export const THEMES = {
  LIGHT: 'light',
  DARK: 'dark',
};

const THEME_COLORS = {
  [THEMES.LIGHT]: '#f4f6f9',
  [THEMES.DARK]: '#0b0e1b',
};

export function getSystemTheme() {
  return window.matchMedia('(prefers-color-scheme: dark)').matches
    ? THEMES.DARK
    : THEMES.LIGHT;
}

export function getStoredTheme() {
  const stored = localStorage.getItem(THEME_STORAGE_KEY);
  return stored === THEMES.DARK || stored === THEMES.LIGHT ? stored : null;
}

export function getTheme() {
  return getStoredTheme() || getSystemTheme();
}

export function applyTheme(theme) {
  const resolved = theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  document.documentElement.setAttribute('data-theme', resolved);

  const meta = document.querySelector('meta[name="theme-color"]');
  if (meta) {
    meta.setAttribute('content', THEME_COLORS[resolved]);
  }
}

export function setTheme(theme) {
  const resolved = theme === THEMES.DARK ? THEMES.DARK : THEMES.LIGHT;
  localStorage.setItem(THEME_STORAGE_KEY, resolved);
  applyTheme(resolved);
  return resolved;
}

export function initTheme() {
  applyTheme(getTheme());
}

export function toggleTheme() {
  const next = getTheme() === THEMES.DARK ? THEMES.LIGHT : THEMES.DARK;
  return setTheme(next);
}
